var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5762 12C21.5762 17.2467 17.3229 21.5 12.0762 21.5C6.82947 21.5 2.57617 17.2467 2.57617 12C2.57617 6.75329 6.82947 2.5 12.0762 2.5C17.3229 2.5 21.5762 6.75329 21.5762 12Z",
    fill: "white",
    stroke: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0762 11C13.0762 10.4477 12.6285 10 12.0762 10C11.5239 10 11.0762 10.4477 11.0762 11V16C11.0762 16.5523 11.5239 17 12.0762 17C12.6285 17 13.0762 16.5523 13.0762 16V11Z",
    fill: "#8E8E8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0762 8C13.0762 7.44772 12.6285 7 12.0762 7C11.5239 7 11.0762 7.44772 11.0762 8C11.0762 8.55228 11.5239 9 12.0762 9C12.6285 9 13.0762 8.55228 13.0762 8Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/infoCircle.8153e671c44020d7f0a02f6026b9cc3c.svg";
export { ForwardRef as ReactComponent };